import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useCookie3 } from "../../../context/Cookie3Provider";
import { useAppDispatch, useAppSelector } from "../../../redux";
import { staking } from "../../../redux/features/stakingSlice";
import AnimatedContainer from "../../components/AnimatedContainer/AnimatedContainer";
import Wallet from "../Wallet/Wallet";
import * as S from "./Dashboard.styled";
import { DashboardInfo } from "./DashboardInfo";

const Dashboard = () => {
  const { isLogged } = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();

  const cookie3 = useCookie3();

  useEffect(() => {
    cookie3?.trackPageView();
  }, []);

  useEffect(() => {
    if (isLogged) dispatch(staking.getStakingData());
  }, [isLogged]);

  return (
    <>
      <Helmet>
        <title>Soil - Dashboard</title>
      </Helmet>
      <AnimatedContainer>
        <S.Wrapper>
          <S.LeftSection>
            <DashboardInfo />
            <Wallet />
          </S.LeftSection>
        </S.Wrapper>
      </AnimatedContainer>
    </>
  );
};

export default Dashboard;
